<template>
  <div class="team" v-loading="loading">
    <div class="team-dialog">
      <div class="goback" @click="goBack">
        <i class="el-icon-arrow-left"></i>
        <span>返回登录</span>
      </div>
      <div class="team-con">
        <h3>您所在的团队</h3>
        <p>以下为您当前账号所加入的团队，可点击名称进入团队</p>
        <div class="team-list">
          <el-scrollbar style="height: 100%; overflow-x: hidden">
            <ul>
              <li
                v-for="team in teamList"
                :key="team.id"
                class="team-li"
                @click="toHref(team)"
              >
                <div class="team-logo">
                  <img v-if="team.logo" :src="team.logo" />
                </div>
                <el-popover
                  placement="left"
                  width="200"
                  trigger="hover"
                  :content="team.name"
                >
                  <p class="text-hidden" slot="reference">{{ team.name }}</p>
                </el-popover>
                <!-- <p class="text-hidden">{{ team.name }}</p> -->
              </li>
            </ul>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { changeTeam, getTeam, Login } from "@/config/axios/new_api";
import tokenFunc from "@/config/static/token";
export default {
  data() {
    return {
      teamList: [],
      loading: false,
    };
  },
  created() {
    this.checkShare();
  },
  computed: {
    loginInfo() {
      return this.$store.getters.loginInfo;
    },
  },
  methods: {
    async getData (flag) {
      let href = this.loginInfo.current_team_domain;
      console.log(href, 'Team.getData')
      if (href && process.env.NODE_ENV === "production") {
        if (process.env.VUE_APP_RealmName) {
          href = href.split(".")[0] + `.${process.env.VUE_APP_RealmName}`;
        }
        console.log(href, 'Team.getData process.env.NODE_ENV === "production"')
        window.location.href = `https://${href}`;
      } else {
        if(flag) {
          let { data } = await getTeam();
          this.teamList = data;
        }
        if (!(this.teamList && this.teamList.length)) {
          let url = process.env.VUE_APP_BASELogout;
          window.location.href = url.substr(0, url.length - 6) + window.location.search;
        }
      }
    },
    // 判断是否有分享参数
    checkShare(){
      if(process.env.NODE_ENV === "production" && this.$route.query.folder) {
        getTeam().then((res) => {
          this.teamList = res.data;
          let shareDomain;
          if(this.teamList && this.teamList.length) {
            shareDomain = this.teamList.find(i => {
              if(i.domain.indexOf('//') > 0) {
                return i.domain.split('//')[1].split('.')[0] == this.$route.query.folder.split('_')[2]
              }else {
                return false
              }
            });
          }
          if(shareDomain) {
            location.href = "https://" + shareDomain.domain.split("//")[1] + this.$route.query.folder.split('_')[0] + '?folder=' + this.$route.query.folder;
          }else {
            this.getData(false);
          }
        });
      }else {
        this.getData(true)
      }
    },
    goBack () {
      loginSdk
          .requestAction('logout').then(res => {
            window.sessionStorage.clear();
            tokenFunc.setToken('')
            this.$router.replace({ name: "Login" });
          })
      // if (process.env.NODE_ENV === "production") {
      //   loginSdk
      //     .requestAction('logout').then(res => {
      //       window.sessionStorage.clear();
      //       tokenFunc.setToken('')
      //       this.$router.replace({ name: "Login" });
      //     })
      //   // Login.logout().then(() => {
      //   // });
      // } else {

      //   // tokenFunc.logout().then(code => {
      //   //   if (!code) {
      //   //     this.$router.replace({ name: "Login" });
      //   //   }
      //   // })
      // }
    },
    toHref(team) {
      // if (!team.domain) {
      //   this.$alert("请先配置您的二级域名", "提示");
      //   return;
      // }
      changeTeam({
        team_id: team.id,
      }).then((res) => {
        if (res.status === 1) {
          let domain = `${team.domain}`;
          if (process.env.VUE_APP_RealmName) {
            // 配置域名
            domain =
              "https://" +
              domain.split("//")[1].split(".")[0] +
              `.${process.env.VUE_APP_RealmName}`;
          }
          if (team.is_open === 2) {
            if (process.env.NODE_ENV === "production") {
              this.staticFunc.toHref(domain);
            } else {
              this.staticFunc.toHref("/home");
            }
          } else {
            if (process.env.NODE_ENV === "production") {
              this.staticFunc.toHref(`${domain}/template`);
            } else {
              this.staticFunc.toHref("/template");
            }
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
.team {
  background: #2d2d36;
  opacity: 0.7;
  width: 100%;
  height: 100vh;
  .team-dialog {
    width: 480px;
    height: 460px;
    padding: 35px 48px 0;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #ffffff;
    border-radius: 12px;
  }
  .goback {
    color: #646469;
    line-height: 20px;
    margin-bottom: 19px;
    width: 100px;
    cursor: pointer;
    span {
      margin-left: 7px;
    }
  }
  .team-list {
    width: 384px;
    height: 270px;
    padding: 3px 6px;
    margin-top: 20px;
    .el-scrollbar__wrap {
      overflow-y: scroll;
      overflow-x: hidden;
    }
    ul {
      margin-top: 10px;
      padding-right: 10px;
    }
    .team-li {
      width: 100%;
      height: 48px;
      line-height: 48px;
      display: flex;
      margin-bottom: 10px;
      border-radius: 5px;
      cursor: pointer;
      &:hover {
        background-color: #ccc;
      }
      .team-logo {
        width: 98px;
        height: 48px;
        margin-right: 20px;
        padding: 5px 10px;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
